import { useState } from 'react';
import { Button, Dropdown, Layout, Menu } from 'antd';
import {
  AppstoreOutlined,
  DashboardOutlined,
  DownOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  SafetyCertificateOutlined,
  ShopOutlined,
  ShoppingOutlined,
  TeamOutlined,
} from '@ant-design/icons';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

const { Header, Sider, Content } = Layout;

const menuItems = [
  { key: '/dashboard', icon: <DashboardOutlined />, label: '数据概览' },
  { key: '/users', icon: <TeamOutlined />, label: '用户管理' },
  { key: '/stores', icon: <ShopOutlined />, label: '店铺管理' },
  { key: '/products', icon: <AppstoreOutlined />, label: '系统商品' },
  { key: '/orders', icon: <ShoppingOutlined />, label: '订单管理' },
  {
    key: 'security',
    icon: <SafetyCertificateOutlined />,
    label: '安全中心',
    children: [{ key: 'logout', icon: <LogoutOutlined />, label: '退出登录' }],
  },
];

export default function Main() {
  const [collapsed, setCollapsed] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const user = (() => {
    try {
      return JSON.parse(localStorage.getItem('user')) || {};
    } catch (e) {
      return {};
    }
  })();

  const logout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    navigate('/login', { replace: true });
  };

  const onMenuClick = ({ key }) => {
    if (key === 'logout') {
      logout();
      return;
    }
    navigate(key);
  };

  return (
    <Layout style={{ height: '100vh' }}>
      <Sider theme="dark" width={200} collapsed={collapsed} trigger={null} collapsible>
        <div className="admin-logo">{collapsed ? 'HS' : 'Huboo Shopping'}</div>
        <Menu
          theme="dark"
          mode="inline"
          items={menuItems}
          selectedKeys={[location.pathname]}
          onClick={onMenuClick}
        />
      </Sider>
      <Layout style={{ height: '100vh', overflow: 'hidden' }}>
        <Header className="admin-header">
          <Button
            type="text"
            className="admin-collapse"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed((value) => !value)}
          />
          <Dropdown
            trigger={['click']}
            menu={{
              items: [{ key: 'logout', icon: <LogoutOutlined />, label: '退出登录' }],
              onClick: logout,
            }}
          >
            <div className="admin-header-user">
              {user.nickname || user.username || user.email || 'admin'}
              <DownOutlined />
            </div>
          </Dropdown>
        </Header>
        <Content className="admin-content">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}
